/** Filipino na bersyon ng Web App Studio. Kapareho ng en ang mga key (sinusuri ng test). */
export const webappStudio = {
  app: {
    share: {
      title: "I-share ang {{name}}",
      hint: "Sinumang may link na ito ay makakabukas ng assistant at makakapagsimula ng chat.",
      signedInOnly: "Para lang sa mga naka-sign in na customer ang assistant na ito, kaya walang pampublikong link na maibabahagi. Makakarating ang mga customer dito mula sa website o app na pinag-sign in-an nila.",
      signedInOnlyHint: "Walang bahagi ng iyong session ang inilalagay sa link.",
      linkLabel: "Link sa assistant na ito",
      copy: "Kopyahin ang link",
      copied: "Nakopya na ang link",
      copyFailed: "Hindi makopya. Piliin ang link at kopyahin nang mano-mano.",
      native: "I-share…",
      qrLabel: "QR code ng link sa assistant na ito",
      qrHint: "I-scan gamit ang camera ng telepono para buksan ang chat.",
      private: "Hindi kailanman isinasama sa link ang iyong sign-in, launch code o anumang usapan.",
      dialogTitle: "I-share",
      dialogHint: "Piliin kung ano ang ibabahagi.",
      choiceLabel: "Ano ang gusto mong i-share?",
      modes: { conversation: "Ang usapang ito", assistant: "Ang assistant" },
      conversation: {
        title: "I-share ang usapang ito",
        explain: "Mababasa ng sinumang may link ang mga mensahe sa chat na ito hanggang ngayon, nang hindi nagsa-sign in. Hindi kasama ang mga mensaheng ipapadala mo pagkatapos. Nananatiling nakatago ang mga code, PIN at card number, at hindi kailanman ipinapakita ang pangalan at detalye ng iyong account.",
        create: "Gumawa ng link",
        creating: "Ginagawa ang link…",
        created: "Nagawa na ang link. Kopyahin ito at ipadala kahit kanino.",
        linkLabel: "Link sa usapang ito",
        qrLabel: "QR code para sa link sa usapang ito",
        qrHint: "I-scan gamit ang camera ng telepono para mabasa ang usapan.",
        copied: "Nakopya ang link ng usapan",
        another: "Gumawa ng isa pang link",
        failed: "Hindi namin nagawa ang link. Pakisubukan ulit.",
        disabled: "Naka-off ang pag-share para sa assistant na ito, kaya hindi maibabahagi ang usapang ito.",
        tooMany: "Marami ka nang nagawang link ngayon. Maghintay sandali, saka subukan ulit.",
        limit: "Nasa pinakamaraming naibahaging link na ang chat na ito. Itigil muna ang pag-share ng isa.",
        nothing: "Magpadala muna ng mensahe at hintaying masagot, saka mo maibabahagi ang chat.",
        unsafe: "Hindi kami nakagawa ng ligtas na link. Pakisubukan ulit.",
      },
      links: {
        title: "Mga naibahaging link",
        count_one: "{{count}} link ang bukas",
        count_other: "{{count}} link ang bukas",
        emptyTitle: "Wala pang naibahaging link",
        emptyBody: "Kapag gumawa ka ng link sa usapang ito, ililista ito dito para maitigil mo ang pag-share.",
        row: "Naibahagi {{when}}",
        messages_one: "{{count}} mensahe",
        messages_other: "{{count}} mensahe",
        expires: "Mag-e-expire {{when}}",
        stop: "Itigil ang pag-share",
        stopLabel: "Itigil ang pag-share ng link mula {{when}}",
        stopped: "Naitigil na. Hindi na nabubuksan ang link na iyon.",
        stopFailed: "Hindi namin naitigil ang pag-share. Pakisubukan ulit.",
        loadFailed: "Hindi namin ma-load ang iyong mga naibahaging link.",
      },
    },
  snapshot: {
    title: "Ibinahaging usapan kasama si {{name}}",
    banner: "Ibinahaging usapan · basahin lang",
    bannerHint: "Kopya ito ng isang chat. Walang maaaring baguhin o sagutin dito.",
    asOf: "Naibahagi {{when}}",
    log: "Mga mensahe sa ibinahaging usapan",
    start: "Magsimula ng sarili mong chat",
    startHint: "Itanong kay {{name}} ang sarili mong tanong.",
    notFoundTitle: "Hindi available ang ibinahaging usapang ito",
    notFoundBody: "Maaaring itinigil na ng nag-share ang pag-share, o nag-expire na ang link. Humingi ng bagong link sa kanila.",
    goHome: "Buksan si {{name}}",
    errorTitle: "Hindi namin ma-load ang usapang ito",
    errorBody: "Tingnan ang iyong koneksyon at subukan ulit.",
    busyTitle: "Maraming nagbubukas ng link ngayon",
    busyBody: "Maghintay sandali at subukan ulit.",
    loading: "Nilo-load ang ibinahaging usapan",
    team: "Team",
  },
  },
  console: {
    title: "Web App Studio",
    subtitle: "Idisenyo ang hosted chat page ng {{agent}}. Agad na live ang mga pagbabago kapag nai-save.",
    tabsLabel: "Mga setting ng web app",
    tabs: { branding: "Branding", icons: "Mga icon", content: "Nilalaman", layout: "Layout", share: "I-share" },
    scope: {
      label: "Ineedit",
      assistant: "Ang assistant na ito",
      default: "Default ng workspace",
      assistantHint: "Ang {{agent}} lang ang gumagamit ng disenyong ito.",
      defaultHint: "Gamit ng bawat assistant na walang sariling disenyo. Bawat assistant ang nagtatakda ng mga larawan.",
      locked: "I-save o itapon muna ang mga pagbabago para lumipat.",
    },
    source: {
      assistant: "Ang {{agent}} ay may sariling disenyo.",
      default: "Sinusunod ng {{agent}} ang default na disenyo ng workspace.",
      widget: "Wala pang naka-save na disenyo: sinusunod ng web app ang Widget Studio (avatar at kulay) at ang logo ng workspace.",
    },
    branding: {
      appName: "Pangalan ng app",
      appNamePlaceholder: "Ang pangalan ng app ng workspace ang default",
      appNameHint: "Makikita sa sidebar at sa tab ng browser.",
      logo: "Logo",
      logoHint: "Kapag walang laman, ginagamit ang logo ng workspace mula sa Settings > Organization.",
      avatar: "Avatar ng assistant",
      avatarWidget: "Kapareho ng Widget",
      avatarCustom: "Mag-upload dito",
      avatarInitials: "Mga initial",
      avatarHint: "Ipinapakita ng \"Kapareho ng Widget\" ang avatar sa Widget Studio, kasunod ang logo ng workspace.",
      favicon: "Favicon",
      faviconHint: "Ang maliit na icon sa tab ng browser. PNG, JPEG o WebP hanggang 2 MB.",
      upload: "Mag-upload",
      uploading: "Nag-a-upload…",
      replace: "Palitan",
      remove: "Alisin",
      uploaded: "Na-upload ang {{name}}",
      invalid: "Gumamit ng PNG, JPEG o WebP na hanggang 2 MB.",
      failed: "Hindi nag-upload. Subukan ulit.",
      accent: "Kulay ng accent",
      accentSame: "Kapareho ng Widget",
      accentCustom: "Sariling kulay",
      accentHint: "Ginagamit ng \"Kapareho ng Widget\" ang kulay mula sa Widget Studio.",
      theme: "Default na tema",
      themeHint: "Makakapili pa rin ng tema ang mga bisita; ang pinili nila ang masusunod.",
      themeSystem: "Sundin ang device",
      themeLight: "Maliwanag",
      themeDark: "Madilim",
      density: "Siksik",
      comfortable: "Maluwag",
      compact: "Siksik",
      radius: "Bilog ng mga sulok",
      radiusWidget: "Kapareho ng Widget",
      radiusCustom: "Sarili",
      radiusValue: "{{px}} px",
      noPictures: "Sa isang assistant ang mga larawan. Lumipat sa \"Ang assistant na ito\" para mag-upload.",
    },
    icons: {
      hint: "Nananatili ang mga accessible na pangalan ng icon; larawan lang ang nagbabago.",
      assistantIcon: "Icon ng assistant",
      assistantAvatar: "Larawan ng avatar",
      cardIcon: "Icon ng mga suhestiyon",
      cardAuto: "Piliin mula sa tanong",
      cardNone: "Walang icon",
      sendStyle: "Button na Send",
      sendIcon: "Icon lang",
      sendLabel: "Icon at \"Send\"",
      icons: {
        bot: "Bot",
        sparkles: "Kislap",
        "graduation-cap": "Graduation cap",
        headset: "Headset",
        "message-circle": "Chat bubble",
        "life-buoy": "Salbabida",
        "book-open": "Bukas na aklat",
        brain: "Utak",
        heart: "Puso",
        star: "Bituin",
        zap: "Kidlat",
        "building-2": "Gusali",
        "help-circle": "Tandang pananong",
        "file-text": "Dokumento",
        wallet: "Pitaka",
        calendar: "Kalendaryo",
        "map-pin": "Pin sa mapa",
        "list-checks": "Checklist",
      },
    },
    content: {
      hint: "Iwanang walang laman ang field para manatili ang karaniwang salita. Sa Filipino, English ang fallback.",
      title: "Pamagat ng welcome",
      titlePlaceholder: "Hi there! How can I help today?",
      subtitle: "Subtitle ng welcome",
      placeholder: "Placeholder ng message box",
      disclaimer: "Disclaimer sa ibaba",
      starters: "Mga iminumungkahing tanong",
      startersWidget: "Kapareho ng mga starter question ng assistant",
      startersCustom: "Isulat ang sarili ko",
      startersEmpty: "Wala pang starter question. Magdagdag sa Widget Studio, o isulat ang sarili dito.",
      startersMax: "Hanggang {{max}} tanong.",
      addStarter: "Magdagdag ng tanong",
      starterLabel: "Tanong {{n}}",
      removeStarter: "Alisin ang tanong {{n}}",
      moveUp: "Itaas ang tanong {{n}}",
      moveDown: "Ibaba ang tanong {{n}}",
      en: "English",
      fil: "Filipino",
    },
    layout: {
      showHistory: "Ipakita ang history ng usapan",
      showHistoryHint: "Ang listahan at paghahanap ng mga naunang chat sa sidebar. Laging nariyan ang New chat.",
      guestNotice: "Paalala sa guest",
      guestNoticeHint: "Sinasabi sa mga bisitang nagchachat nang hindi nagsa-sign in.",
      poweredBy: "\"Powered by Sagot\"",
      poweredByHint: "Kapareho ng patakaran sa Widget Studio: maitatago lang ito sa mga planong may pag-alis ng branding.",
      poweredByWidget: "Sundin ang Widget Studio",
      poweredByShow: "Laging ipakita",
      poweredByHide: "Itago",
      poweredByLocked: "Kasama sa mga planong may pag-alis ng branding ang pagtatago nito.",
    },
    share: {
      enabled: "Ipakita ang button na Share",
      enabledHint: "Makokopya ng mga bisita ang pampublikong link, magagamit ang share sheet ng device, o makakapag-scan ng QR code.",
      link: "Pampublikong link",
      linkHint: "Ang na-verify na custom domain kung mayroon, kung wala ay ang address ng platform. Hindi ito naglalaman ng sign-in o launch code.",
      copy: "Kopyahin ang link",
      copied: "Nakopya na ang link",
    },
    preview: {
      live: "Live na preview",
      liveHint: "ng web app, kasama ang mga hindi pa nai-save na pagbabago",
      device: "Laki ng preview",
      desktop: "Desktop",
      mobile: "Mobile",
      theme: "Tema ng preview",
      light: "Maliwanag",
      dark: "Madilim",
      open: "Buksan ang web app",
      openLabel: "Buksan ang web app sa bagong tab",
      unsaved: "Hindi pa nai-save",
      assistantName: "Assistant",
    },
    save: "I-save",
    saving: "Sine-save…",
    discard: "Itapon",
    saved: "Nai-save ang disenyo ng web app",
    saveFailed: "Hindi ma-save ang disenyo.",
    reset: "Gamitin ang default ng workspace",
    resetDefault: "Alisin ang default ng workspace",
    resetDone: "Na-reset ang disenyo",
    resetFailed: "Hindi ma-reset ang disenyo.",
    loadError: "Hindi ma-load ang Web App Studio.",
    loadErrorBody: "Tingnan ang koneksyon at subukan ulit.",
    notFoundTitle: "Hindi nahanap ang assistant",
    notFoundBody: "Maaaring natanggal na ang assistant na ito. Pumili ng iba sa menu ng agent.",
    readOnly: "Makikita mo ang disenyong ito pero hindi mo ito mababago.",
  },
};
